import { Controller } from "@hotwired/stimulus"

// Recarga /internal/status cada dos minutos para que quien la deje abierta en una
// pestaña vea el estado real y no el de cuando entró. El snapshot se recalcula
// cada 5 min (cron), así que refrescar más a menudo no aportaría datos nuevos.
//
// Se pausa en cuanto alguien escribe en el buscador: recargar bajo los dedos
// borraría el filtro que acaba de teclear.
const INTERVALO_MS = 120000

export default class extends Controller {
  connect() {
    this.temporizador = setInterval(() => this.recargar(), INTERVALO_MS)
  }

  disconnect() {
    clearInterval(this.temporizador)
  }

  pausar() {
    clearInterval(this.temporizador)
  }

  recargar() {
    if (document.hidden) return

    window.location.reload()
  }
}
